$(function () {

	"use strict";


	// loader
	window.onload = function(){
		setTimeout(function(){
		var loader = document.getElementsByClassName("loader")[0];
		loader.className="loader fadeout" ;
		setTimeout(function(){loader.style.display="none"},1000)
		},1000)
	}
	// Sticky
	$(window).on('scroll', function (event) {
		var scroll = $(window).scrollTop();
		if (scroll > 110) {
			$("header").addClass("sticky");
			$('.sticky_contact').addClass("d-flex");

		} else {
			$("header").removeClass("sticky");
			$('.sticky_contact').removeClass("d-flex");
		}
	});

	// Smooth scrolling when clicking on a hash link
	var taboffset = $('.header-wrapper').height();
	$('a[href^="#"]').on('click',function (e) {
		e.preventDefault();
		var target = this.hash;
		var $target = $(target);
		$('html, body').stop().animate({
			'scrollTop': $target.offset().top - taboffset - 0
		}, 0, 'swing');
	});

	// toggleMenu
	// const toggleMenuClicked = () => {
	// 	const body = document.body;
	// 	const openIcon = document.getElementById("open-icon");
	// 	const closeIcon = document.getElementById("close-icon");

	// 	body.classList.toggle("open");

	// 	if (body.classList.contains("open")) {
	// 		openIcon.style.display = "none";
	// 		closeIcon.style.display = "flex";
	// 	} else {
	// 		openIcon.style.display = "flex";
	// 		closeIcon.style.display = "none";
	// 	}
	// };
	
	// let videoTitle;
	// let videoDesc;
	// let videoSrc;
	// let v_title;
	// let v_desc;
	
	// // 1. Get the video details.
	// $('.video_box').on('click', function() {
	// 	// let clickData = $(this).data();
	// 	// for (const key in clickData) {
	// 	// 	console.log(`${key}: ${clickData[key]}`);
	// 	// 	alert(`${key}: ${clickData[key]}`);
	// 	// };

	// 	videoTitle = $(this).data("title");
	// 	videoDesc = $(this).data("desc");
	// 	videoSrc = $(this).data("src");
	// });

	// // 2. When the modal is opened autoplay it
	// $('#videoModal').on('shown.bs.modal', function(e) {
	// 	// Set the video title.
	// 	v_title = document.getElementById("v_title");
	// 	// if (videoTitle.length != 0) {
	// 	if (typeof videoTitle !== 'undefined' || videoTitle !== null) {
	// 		v_title.innerHTML = videoTitle;
	// 	}else{
	// 		v_title.style.display = "none";
	// 	}

	// 	// Set the video description.
	// 	v_desc = document.getElementById("v_desc");
	// 	if (typeof videoDesc !== 'undefined' || videoDesc !== null) {
	// 		v_desc.innerHTML = videoDesc;
	// 		$("#v_desc").addClass("pb-2");
	// 	}else{
	// 		v_desc.style.display = "none";
	// 	}
		
	// 	// set the video src to autoplay.
	// 	$("#video").attr('src',videoSrc + "?autoplay=1&rel=0&amp;modestbranding=1&amp;showinfo=0");
	// });
	
	// // 3. Stop playing the youtube video when I close the modal
	// $('#videoModal').on('hide.bs.modal', function(e) {
	// 	$("#video").attr('src',videoSrc);
	// });

	// FAQs Tab
	$(document).ready(function() {
		$(".faq_menu_item").click(function() {
			$(".faq_menu_item").removeClass("active");
			$(this).addClass("active");
		});
		$(window).scroll(function() {
			if ($(window).scrollTop() >= 100) {
				$('.faq_menu_holder').addClass('fixed_faq_menu');
			} else {
				$('.faq_menu_holder').removeClass('fixed_faq_menu');
			}
		});
		$('a[href^="#"]').on('click', function(e) {
			e.preventDefault();
			var target = this.hash;
			var $target = $(target);
			$('html, body').stop().animate({
				'scrollTop': $target.offset().top - 300
			}, 100, 'swing');
		});
	});

}); // document ready

